import React from 'react'

import Button from 'components/ui/button'
import { IEditableTableHead } from './head'
import Input from 'components/ui/input'
import { IEditableItem } from 'components/layout/editableTable'

interface IProps {
  head: IEditableTableHead[]
  onCancel?: () => void
  onAdd?: (data: IEditableItem) => void
}

const ItemCreator: React.FC<IProps> = ({ head, onCancel, onAdd }) => {
  // TODO: Get id from databse
  // Only Temporary creation of id
  // TODO: Pass productName from parent component
  // Necessary to use IEditableData interface for consistent typing
  const [item, setItem] = React.useState<IEditableItem>({
    id: String(Date.now()),
    productName: '',
    custom: true,
  })

  const handleDelete = () => {
    setItem({ ...item, data: {} })
  }

  const hasKey = (key: string) => item.data && item.data[key]

  const hasUnit = (headItem: IEditableTableHead) => (headItem.unit ? true : false)

  const getValue = (key: string) => (hasKey(key) ? item.data![key].value : '')

  const getUnit = (headItem: IEditableTableHead) =>
    hasUnit(headItem) && item.data && item.data[headItem.key] && item.data[headItem.key].unit
      ? item.data[headItem.key].unit
      : ''

  return (
    <div className="my-45">
      <div className="flex">
        {head.map((headItem: IEditableTableHead) => (
          <div key={headItem.key} className={`flex w-${headItem.col}/12 pl-30 first-child:pl-0`}>
            <div className={`flex ${hasUnit(headItem) ? 'w-8/12' : 'w-full'}`}>
              <Input
                type={hasUnit(headItem) ? 'number' : 'text'}
                unit={hasUnit(headItem) ? getUnit(headItem) : undefined}
                value={getValue(headItem.key)}
                name={headItem.key}
                onChange={value =>
                  setItem({
                    ...item,
                    data: {
                      ...item.data,
                      [headItem.key]: {
                        ...(hasKey(headItem.key) ? item.data![headItem.key] : []),
                        value,
                      },
                    },
                  })
                }
                placeholder={headItem.placeholder}
                underline
                leftAlign={headItem.leftAlign}
              />
            </div>
            {hasUnit(headItem) && (
              <div className="flex w-4/12 ml-15">
                <Input
                  value={getUnit(headItem)}
                  name={`${headItem.key}-unit`}
                  onChange={unit =>
                    setItem({
                      ...item,
                      data: {
                        ...item.data,
                        [headItem.key]: {
                          ...(hasKey(headItem.key) ? item.data![headItem.key] : []),
                          value:
                            item.data && hasKey(headItem.key) ? item.data[headItem.key].value : '',
                          unit: hasUnit(headItem) ? String(unit) : undefined,
                        },
                      },
                    })
                  }
                  placeholder={headItem.unit}
                  underline
                  leftAlign={headItem.leftAlign}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="flex justify-between mt-30">
        <div>
          <Button
            className="mr-15"
            primary
            onClick={() => {
              if (onAdd) {
                onAdd(item)
              }
            }}
          >
            Hinzufügen
          </Button>
          <Button
            secondary
            onClick={() => {
              if (onCancel) {
                onCancel()
              }
            }}
          >
            Abbrechen
          </Button>
        </div>
        <Button secondary danger onClick={handleDelete}>
          Löschen
        </Button>
      </div>
    </div>
  )
}

export default ItemCreator
